import { render, staticRenderFns } from "./FooterOutside.vue?vue&type=template&id=f51611a8&scoped=true"
import script from "./FooterOutside.vue?vue&type=script&lang=js"
export * from "./FooterOutside.vue?vue&type=script&lang=js"
import style0 from "./FooterOutside.vue?vue&type=style&index=0&id=f51611a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51611a8",
  null
  
)

export default component.exports